"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenToOklchToken = exports.oklchToRgb = exports.hexToOklch = void 0;
const fn_1 = require("culori/require");
// eslint-disable-next-line react-hooks/rules-of-hooks
const oklch = (0, fn_1.useMode)(fn_1.modeOklch);
// eslint-disable-next-line react-hooks/rules-of-hooks
const rgb = (0, fn_1.useMode)(fn_1.modeRgb);
const hexToOklch = (hex) => {
    const result = oklch((0, fn_1.formatHex)(hex));
    if (!result)
        throw new Error(`[Reshaped] Can't convert ${hex} to oklch`);
    return result;
};
exports.hexToOklch = hexToOklch;
const oklchToRgb = (oklch) => {
    const value = rgb(oklch);
    return {
        ...value,
        r: Number(value.r.toFixed(4)),
        g: Number(value.g.toFixed(4)),
        b: Number(value.b.toFixed(4)),
    };
};
exports.oklchToRgb = oklchToRgb;
const tokenToOklchToken = (token) => {
    const hexDarkFallback = token.hexDark ? (0, exports.hexToOklch)(token.hexDark) : undefined;
    return {
        oklch: token.oklch ? { ...token.oklch, mode: "oklch" } : (0, exports.hexToOklch)(token.hex),
        oklchDark: token.oklchDark ? { ...token.oklchDark, mode: "oklch" } : hexDarkFallback,
    };
};
exports.tokenToOklchToken = tokenToOklchToken;
